import { Component, OnInit, Input, HostListener } from "@angular/core";
import { AuthService } from "../../services/authorization/auth.service";
import { Router } from "@angular/router";
import { Subscription } from "rxjs";
import { ItemService } from './../../services/items/item.service';

@Component({
  selector: "app-header",
  templateUrl: "./header.component.html",
  styles: [],
})
export class HeaderComponent implements OnInit {
  public innerWidth: any;
  public displayTextLogo = true;
  public lang = 'root';
  public langSub: Subscription;
  public dropdownClass = "flag-icon flag-icon-es";
  constructor(public auth: AuthService, public router: Router, public itemService: ItemService) {
    this.langSub = this.itemService.langSub.subscribe((value) => {
      this.itemService.langSelected = value;
      console.log('holi', `${value}`);
    });
  }

  ngOnInit() {
    this.innerWidth = window.innerWidth;
    if (window.innerWidth <= 1170) {
      this.displayTextLogo = false;
    } else {
      this.displayTextLogo = true;
    }
    
  }

  logOut() {
    this.auth.signOut();
    this.router.navigateByUrl("/login");
  }

  @HostListener("window:resize", ["$event"])
  onResize(event) {
    if (window.innerWidth <= 1170) {
      this.displayTextLogo = false;
    } else {
      this.displayTextLogo = true;
    }
  }

  toggleLogo() {
    if (this.displayTextLogo) {
      this.displayTextLogo = false;
    } else {
      if (window.innerWidth <= 1170) {
        this.displayTextLogo = false;
      } else {
        this.displayTextLogo = true;
      }
    }
  }
  onOptionsSelected(value: string) {
    this.itemService.lang.next(value)
    this.dropdownClass = `flag-icon flag-icon-${value}`;
    console.log("the selected value is " + value);
  }
}
